import { useMemo, useRef } from 'react';
import { useScreenshot } from 'use-react-screenshot';
import ScreenshotContext from './ScreenshotContext';

type Props = {
  children: React.ReactNode;
};

const ScreenshotProvider = ({ children }: Props) => {
  const ref = useRef(null);
  const [image, takeScreenshot] = useScreenshot();

  const value = useMemo(
    () => ({
      ref,
      image,
      takeScreenshotOfElement: () => takeScreenshot(ref.current),
    }),
    [ref, image, takeScreenshot],
  );

  return (
    <ScreenshotContext.Provider value={value}>
      <div ref={ref} className='h-100'>
        {children}
      </div>
    </ScreenshotContext.Provider>
  );
};

export default ScreenshotProvider;
